var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingPhone = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2033 0H5.21954C4.23133 0 3.4228 0.818182 3.4228 1.81818V4.54545H5.21954V2.72727H14.2033V17.2727H5.21954V15.4545H3.4228V18.1818C3.4228 19.1818 4.23133 20 5.21954 20H14.2033C15.1915 20 16 19.1818 16 18.1818V1.81818C16 0.818182 15.1915 0 14.2033 0ZM3.43178 11.3364L1.14093 9.01818L0 10.1727L3.4228 13.6364L9.88209 7.1L8.74116 5.94545L3.43178 11.3364V11.3364Z",
    fill: "#A8B1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43178 11.3362L1.14093 9.01804L0 10.1726L3.4228 13.6362L9.88209 7.09986L8.74116 5.94531L3.43178 11.3362Z",
    fill: "#A8B1C1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingPhone.67bc69fb750dfda6753b4bbf8de043c7.svg";